import React from 'react';
import block from 'bem-cn-lite';

import {RoundIcon} from '@yandex-data-ui/cloud-components';
import {ServiceIcon} from 'components/ServiceIcon';

import './ServiceLogo.scss';

export interface ServiceLogoProps {
    service?: string;
    icon?: string | null;
    size?: Size;
    className?: string;
}

type Size = 'l' | 'm' | 's';
const sizeInfo: Record<Size, number> = {
    l: 16,
    m: 12,
    s: 8,
};

const b = block('service-logo-block');

const ServiceLogo: React.FC<ServiceLogoProps> = ({service, className, icon, size = 'l'}) => (
    <RoundIcon className={b({size}, className)} size={size}>
        <ServiceIcon name={service} icon={icon} size={sizeInfo[size]} />
    </RoundIcon>
);

export default ServiceLogo;
